module.exports = __webpack_public_path__ + "img/m-wash3pro-front.646d831e.jpg";